export const jokes = [
  {
    id: 1,
    created_at: "2024-11-28T00:00:00Z",
    content: "Why don't cats play poker in the jungle? Too many cheetahs!",
  },
  {
    id: 2,
    created_at: "2024-11-28T00:00:00Z",
    content:
      "I told my computer I needed a break, now it’s sending me on vacation. Talk about a computer’s 'time off'!",
  },
  {
    id: 3,
    created_at: "2024-11-28T00:00:00Z",
    content: "I used to be a baker, but I couldn't make enough dough!",
  },
  {
    id: 4,
    created_at: "2024-11-28T00:00:00Z",
    content: "What do you call a dog magician? A labracadabrador!",
  },
  {
    id: 5,
    created_at: "2024-11-28T00:00:00Z",
    content:
      "I tried inventing a belt made out of watches. It was a waist of time!",
  },
  {
    id: 6,
    created_at: "2024-11-28T00:00:00Z",
    content:
      "I grilled a lot of steaks last weekend, but now I’m feeling a little burnt out.",
  },
  {
    id: 7,
    created_at: "2024-11-28T00:00:00Z",
    content:
      "Parallel lines have so much in common. It’s a shame they’ll never meet!",
  },
  {
    id: 8,
    created_at: "2024-11-28T00:00:00Z",
    content:
      "I went to a pub last night, but they didn't have any 'good' jokes. Just a lot of 'liquid humor'!",
  },
  {
    id: 9,
    created_at: "2024-11-28T00:00:00Z",
    content:
      "I burned my dinner last night... But on the bright side, I finally found my smoke detector's true calling!",
  },
  {
    id: 10,
    created_at: "2024-11-28T00:00:00Z",
    content:
      "I bought a banana, but I think it’s going bad. It’s feeling a bit peel-ish!",
  },
  {
    id: 11,
    created_at: "2024-11-30T00:00:00Z",
    content: "Why is Peter Pan always flying? Cause he Neverlands.",
  },
  {
    id: 12,
    created_at: "2024-11-30T00:00:00Z",
    content:
      "A girl walked up to me and said Hi, I'm Tiina with two 'i's. I replied Hey, I'm Steve with two ears.",
  },
  {
    id: 13,
    created_at: "2024-11-30T00:00:00Z",
    content: "What do you call a sad cup of coffee? Depresso.",
  },
  {
    id: 14,
    created_at: "2024-11-30T00:00:00Z",
    content:
      "A man just assaulted me with milk, butter, and cheese. How dairy!",
  },
  {
    id: 15,
    created_at: "2024-11-30T00:00:00Z",
    content:
      "I made a graph of my past relationships. It's got an ex-axis and a why-axis.",
  },
  {
    id: 16,
    created_at: "2024-11-30T00:00:00Z",
    content:
      "I have a step ladder at home. My real ladder left to buy cigarettes and never came back.",
  },
  {
    id: 17,
    created_at: "2024-11-30T10:35:00Z",
    content:
      "Why did the bus driver lose his job after giving his seat to a blind person? Because he was the bus driver.",
  },
  {
    id: 18,
    created_at: "2024-11-30T10:50:00Z",
    content:
      "What do you call a joke that's dead? That can’t possibly be... It's been dead for 20 minutes.",
  },
];
